(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp__qty-btn');
    if (!btn) return;

    var qty = btn.closest('.pdp__qty');
    var input = qty.querySelector('.pdp__qty-input');
    var val = parseInt(input.value, 10) || 1;

    if (btn.dataset.action === 'decrease') {
      val = Math.max(1, val - 1);
    } else {
      val = val + 1;
    }

    input.value = val;
    qty.querySelector('[data-action="decrease"]').disabled = val <= 1;
  });

  } catch(e) { console.error(e); }
})();
})();
